
import { Route, Routes, Navigate } from 'react-router-dom';
import HomePage from '../pages/posts/HomePage';
import CreatePostPage from '../pages/posts/create-post/CreatePostPage';
import EditPostPage from '../pages/posts/edit-post/EditPostPage';



const PostsRoutes = () => {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/" element={<Navigate to="/posts/home" />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="create-post" element={<CreatePostPage />}/>
      <Route path="edit-post" element={<EditPostPage />}/>

    </Routes>
  );
};

export default PostsRoutes;
